import { useQuasar } from 'quasar';

export function useLoader() {
  const $q = useQuasar();
  const setIsShowLoading = (isShow: boolean, message?: string) => {
    if (isShow) {
      return $q.loading.show({
        message: message || '',
        boxClass: message ? 'bg-grey-2 text-grey-9' : '',
        spinnerColor: 'primary',
      });
    }

    return $q.loading.hide();
  };

  return {
    setIsShowLoading,
  };
}
